import script from "./CareerDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerDetailPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__